import * as errors from '../constants/errors';
import { critical, warning } from '../logging';
import { LogErrorObject } from '../types/LogErrorObject';

/**
 * Legacy console backup variable
 * @type {{}}
 * @private
 */
const _console = {
    error: (...data: any[]) => {
    }
};

let consoleErrorOverride = false;

/**
 * Overrides the onError event with a logging method.
 */
export function overrideOnError(): void {
    if (typeof window !== 'undefined' && window.onerror === null) {
        window.onerror = (message, section, line, position, error) => LogError({
            error,
            message: String(message),
            section,
            line,
            position,
        });
    }
}

/**
 * Overrides the console.log event with a logging method.
 */
export function overrideConsoleError(): void {
    if (!console || !console.error) {
        throw new Error(errors.NO_CONSOLE);
    }
    if (consoleErrorOverride) {
        return;
    }
    _console.error = console.error;
    console.error = (...param) => {
        _console.error(...param);
        LogError({
            message: param.join(','),
            data: param,
            section: 'console.error',
            logToConsole: false,
        })
    };
    consoleErrorOverride = true;
}

/**
 * Converts an application error to a loggable object.
 * @param config
 * @param {String} config.message
 * @param {Error} [config.error]
 * @param {String} [config.section]
 * @param {number} [config.line]
 * @param {String} [config.position]
 * @param {*} [config.data]
 * @param {Boolean} [config.logToConsole=true]
 */
function LogError({
    error,
    message,
    section,
    line,
    position,
    data,
    logToConsole = true
}: {
    message: string;
    error?: Error | (Error & { code: number });
    section?: string;
    line?: number;
    position?: number;
    data?: any;
    logToConsole?: boolean;
}): void {
    let errorObject: LogErrorObject = {
        data: {
            data,
            position,
            errorCode: (error && 'code' in error) ? error.code : undefined,
            errorName: error ? error.name : undefined,
        },
        fileName: section,
        lineNumber: line,
        section: section,
        message: message,
        ex: {
            message: error ? error.message : message,
            stackTrace: error ? error.stack : new Error().stack,
        },
    };

    if (logToConsole) {
        _console.error(errorObject);
    }

    if (message === 'Script error.' || message === 'Script error') {
        warning(errorObject);
    } else {
        critical(errorObject);
    }
}
